import { render, staticRenderFns } from "./EventParticipation.vue?vue&type=template&id=5504c7d0&scoped=true&"
import script from "./EventParticipation.vue?vue&type=script&lang=js&"
export * from "./EventParticipation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5504c7d0",
  null
  
)

export default component.exports